// @flow
import ResourceCollection from "../base/ResourceCollection";
import ConceptRelationModel from "./ConceptRelationModel";
import type { ModelOptions } from "../types";
import { getBasePathModularUI } from "../../constants";

/**
 * concept relation collection
 */
export default class ConceptRelationCollection extends ResourceCollection<ConceptRelationModel> {
  _entryDate: ?ISO_DATE;
  _modelOptions: ModelOptions;

  /**
   */
  constructor(
    relations: Array<Object> = [],
    entryDate: ?ISO_DATE = null,
    modelOptions?: ModelOptions,
  ) {
    super();

    this._entryDate = entryDate;
    this._modelOptions = modelOptions || {
      origin: "",
      contextPath: getBasePathModularUI(),
    };

    this.collection = Array.isArray(relations)
      ? relations.map((relation) =>
          relation instanceof ConceptRelationModel
            ? relation
            : new ConceptRelationModel(relation, entryDate, modelOptions),
        )
      : [new ConceptRelationModel(relations, entryDate, modelOptions)];
  }

  /**
   * Get unique list of relation types
   */
  get types(): Array<{ key: string, label: string }> {
    return this.collection
      .filter(
        (relation, pos, arr) =>
          arr.findIndex((item) => item.key === relation.key) === pos,
      )
      .map((relation) => ({
        key: relation.key,
        label: relation.label,
      }));
  }

  /**
   * Get relation by its type
   */
  byType(type: string): ConceptRelationCollection {
    return new ConceptRelationCollection(
      this.filter((relation) => relation.key === type),
      this._entryDate,
      this._modelOptions,
    );
  }

  /**
   */
  hasIncoming(): boolean {
    return this.incoming.length > 0;
  }

  /**
   */
  hasOutgoing(): boolean {
    return this.outgoing.length > 0;
  }

  /**
   */
  get incoming(): ConceptRelationCollection {
    return new ConceptRelationCollection(
      this.filter((relation) => relation.direction === "incoming"),
      this._entryDate,
      this._modelOptions,
    );
  }

  /**
   */
  get outgoing(): ConceptRelationCollection {
    return new ConceptRelationCollection(
      this.filter((relation) => relation.direction === "outgoing"),
      this._entryDate,
      this._modelOptions,
    );
  }
}
